import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { FC } from 'react';
import { UpgradeItem } from './UpgradeItem';
import { UpgradeItemV2 } from './v2';
import { UpgradeItemV2Props } from './v2/UpgradeItemV2.types';

export const UpgradeItemVersion: FC<UpgradeItemV2Props> = ({
  originalRoom,
  language,
  ...props
}) => {
  const isV2 = useFeatureIsOn('feature.ecom2');
  if (isV2) return <UpgradeItemV2 originalRoom={originalRoom} language={language} {...props} />;
  return <UpgradeItem {...props} />;
};
